import React from "react";
import { Image, Page, Text, View } from "@react-pdf/renderer";

import CDK_Logo from "../../../images/CDKGlobalWM_BLK.jpg";
import styles from "../PDFStyles/BankingInfo";
import commonStyles from "../PDFStyles/common";
import {
  getBankIFSCCode,
  getBankLocation,
  getBankName
} from "../../../util/onBoardingDataFilters";

const BankingInfo = ({ candidateDetails, otherBankDetails }) => {
  const {
    bankAccountNumber,
    bankBranch,
    bankIFSCCode,
    bankLocation,
    bankName
  } = candidateDetails;
  const { otherBankLocation, otherBankName, otherIFSCCode } = otherBankDetails;

  return (
    <Page size="A4" style={commonStyles.page}>
      <Image style={commonStyles.cdkLogo} src={CDK_Logo} />
      <Text
        style={styles.title}
      >
        Banking Information
      </Text>
      <View
        style={styles.tableLayout}
      >
        <View style={commonStyles.tableRow}>
          <View style={styles.tableKeyCol}>
            <Text style={styles.tableCell}>Name</Text>
          </View>
          <View style={styles.tableValueCol}>
            <Text style={styles.tableCell}>
              {getBankName(bankName, otherBankName) || "-"}
            </Text>
          </View>
        </View>
        <View style={commonStyles.tableRow}>
          <View style={styles.tableKeyCol}>
            <Text style={styles.tableCell}>IFSC Code</Text>
          </View>
          <View style={styles.tableValueCol}>
            <Text style={styles.tableCell}>
              {getBankIFSCCode(bankIFSCCode, otherIFSCCode) || "-"}
            </Text>
          </View>
        </View>
        <View style={commonStyles.tableRow}>
          <View style={styles.tableKeyCol}>
            <Text style={styles.tableCell}>Account Number</Text>
          </View>
          <View style={styles.tableValueCol}>
            <Text style={styles.tableCell}>{bankAccountNumber || "-"}</Text>
          </View>
        </View>
        <View style={commonStyles.tableRow}>
          <View style={styles.tableKeyCol}>
            <Text style={styles.tableCell}>Branch</Text>
          </View>
          <View style={styles.tableValueCol}>
            <Text style={styles.tableCell}>{bankBranch || "-"}</Text>
          </View>
        </View>
        <View style={commonStyles.tableRow}>
          <View style={styles.tableKeyCol}>
            <Text style={styles.tableCell}>Location</Text>
          </View>
          <View style={styles.tableValueCol}>
            <Text style={styles.tableCell}>
              {getBankLocation(bankLocation, otherBankLocation) || "-"}
            </Text>
          </View>
        </View>
      </View>
    </Page>
  );
};

export default BankingInfo;
